module.exports = __webpack_public_path__ + "static/media/SM-MT-TRIAL2-if-worng.78785124.mp3";